@if (hasDineMembership()) {
  <a class="nav-link" routerLink="/dine" id="nav-consultation">
    <div class="icon-container">
      <img src="/assets/images/menu/ICN_Dine.svg"/>
    </div>
    Dine Club
  </a>
  <hr/>
}
